<!-- prettier-ignore -->
<template>
<div class="estados">
 <span>{{titulo}}</span>
<estado v-for='(persona, index) in estados' :key="index"
    v-bind:id='persona.id'
    v-bind:idEstado='persona.id+"id"'
    v-bind:nombre='persona.username'
    v-bind:last_story='persona.last.tipo'
    v-bind:background='persona.last.background'
    v-bind:image='persona.last.image'
    v-bind:video='persona.last.video'
    v-bind:class='{linea:(index<estados.length-1)}'
    v-bind:nStatus ='$store.getters.getEstados(persona.id)'
    v-bind:hora='$store.getters.getHora(persona.id)'
    v-bind:nPersona='persona'
    v-bind:nEstados='$store.getters.getNEstados(persona.id)'
    v-bind:nNuevos='$store.getters.getNNuevos(persona.id)'
    v-bind:stories="stories" @veri="showStory()"></estado>
</div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import estado from "./read";
export default {
  data() {
    return {
      id: null,
    };
  },
  components: {
    estado,
    SweetModal,
  },
  props: {
    inde: {},
    stories: {},
    titulo: { type: String, required: true },
    estados: { type: Array, required: true },
  },
  methods: {
    showStory(id) {
      this.$router.push("/story/" + id);

      // const { id } = nPersona;
    },
    close() {
      this.$refs.myBottomSheet.close();
    },
    getMargin() {
      if (typeof window !== "undefined")
        if (window.innerWidth <= 768) {
          return { "margin-left": this.currentStoryIndex * -100 + "vw" };
        }

      return { "margin-top": this.currentStoryIndex * -100 + "vh" };
    },
  },
  computed: {},
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.estados {
  // border-bottom :0.6px solid rgba(grey,0.7);
  & > span {
    text-align: left;
    display: block;
    padding-left: 1em;
    line-height: 1.35em;
    height: 1.5em;
    font-size: 0.9em;
    // color:grey;
    // background:rgba(grey,0.1);
  }

  .silenciados .estado {
    &::after {
      content: "";
      position: absolute;
      background: white;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0.5;
    }
  }
}

.content {
  background: black;
  height: 90vh;
}
header {
  i {
    cursor: pointer;
    color: white;
    padding: 10px;
    font-size: 1.5em;
    &:first-of-type {
      float: left;
      &:last-child {
        float: right;
      }
    }
  }
  .persona {
    margin-top: 3px;
    margin-left: 0.5em;
    float: left;
    color: white;
    &::after {
      position: absolute;
      content: "";
      width: 54px;
      height: width;
      background: white;
      left: 47px;
      border-radius: 50%;
      z-index: 1;
      margin-top: 1px;
    }
  }
  img {
    border-radius: 50%;
    margin-top: 3px;
    position: relative;
    z-index: 2;
  }
  .datos {
    display: inline-block;
    span {
      position: relative;
      top: -17px;
      left: 15px;
    }
  }

  .progress {
    display: flex;
    justify-content: space-between;
    .progressBar {
      position: relative;
      height: 7px;
      width: 100%;
      margin: 5px;
      border-radius: 10px;
      background: rgba(white, 0.5);
    }
  }
}
.ig-stories {
  position: absolute;
  height: 100vh;
  height: -webkit-fill-available;
  width: 100vw;
  top: 10px;
}

@media (min-width: 768px) {
  .ig-stories {
    position: relative;
    height: 730px;
    width: 420px;
  }
}
</style>
